import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import storyJson from './library/storyJson';
import Front from './Front';
import { animateRkpi, getRkpiDataFromAttrs, getRkpiDurationFromSpeed, rkpiElementV3ToV4 } from './library/elements/richText/froalaTextEditor/utils/rkpi';
import { highlightElementV3ToV4 } from './library/elements/richText/froalaTextEditor/utils/highlight';


declare global {
    interface Window {
        getEnvironmentLink: Function;
    }
}

window.getEnvironmentLink = function getEnvironmentLink() {
    if(process.env.PUBLIC_URL.length) return process.env.PUBLIC_URL;
    if(process.env.REACT_APP_ENV === 'staging') return "https://editor-bundle-staging.storydoc.com"; //staging link
    if(process.env.REACT_APP_ENV === 'production') return "https://editor-bundle.storydoc.com"; //production link
    if(process.env.REACT_APP_ENV === 'dev') return "http://localhost:3000"; //production link
}

document.addEventListener('storydocRender', ((event: CustomEvent) => {

    // validations:
    if (!event.detail) throw new Error('Missing event.detail object');
    if (!event.detail.element) throw new Error('Missing event.detail.element as HTMLElement');

  const appElement =         event.detail.element as HTMLElement

    const root = ReactDOM.createRoot(appElement);
    const storyData = JSON.parse(
        JSON.stringify(event.detail.story ? event.detail.story : storyJson).replace(
        /<\/scr\/ipt>/g,
        '</script>',
        ),
    ); // default to default json

    // RICH_TEXT HIGHLIGHTS AND RKPI //
    const intersectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const item = entry.target;
          if (item.getAttribute('data-highlight-active')) {
            item.setAttribute('data-highlight-active', 'true');
            if (intersectionObserver) intersectionObserver.unobserve(item);
          } else if (item.getAttribute('data-rkpi-active')) {
            item.setAttribute('data-rkpi-active', 'true');
            const { to, from, prefix, suffix, speed } = getRkpiDataFromAttrs(item);
            animateRkpi(item, from, to, getRkpiDurationFromSpeed(speed), prefix, suffix);
            if (intersectionObserver) intersectionObserver.unobserve(item);
          }
        }
      });
    });

    const domObserver = new MutationObserver(() => {
      const v3Highlights = appElement.querySelectorAll(`span.highlight`);
      v3Highlights.forEach((el) => {
        if (el instanceof HTMLElement) highlightElementV3ToV4(el);
      });

      const v3Rkpis = appElement.querySelectorAll(`span[class*='rkpi-']`);
      v3Rkpis.forEach((el) => {
        if (el instanceof HTMLElement) rkpiElementV3ToV4(el);
      });

      const hiEls = appElement.querySelectorAll('[data-highlight-active="false"]');
      const rkpiEls = appElement.querySelectorAll('[data-rkpi-active="false"]');
      hiEls.forEach((e) => {
        if (intersectionObserver) {
          intersectionObserver.observe(e);
        }
      });
      rkpiEls.forEach((e) => {
        if (intersectionObserver) {
          intersectionObserver.observe(e);
        }
      });
    });

    domObserver.observe(appElement, {
      attributes: true,
      childList: true,
      subtree: true,
    });
    // RICH_TEXT HIGHLIGHTS AND RKPI //


    root.render(
        <Front originalData={storyData}/>
    );

}) as EventListener);

document.addEventListener('storydocReplaceCss', ((event: CustomEvent) => {
    if (!event.detail) throw new Error('Missing event.detail object');
    if (!event.detail.cssUrl) throw new Error('Missing event.detail.element as HTMLElement');
    const links = Array.from(document.querySelectorAll('link'));
    const layoutOldLink:any = links.find((link:any) => link.getAttribute('href').indexOf('layout-temp.css') > -1 || link.getAttribute('href').indexOf('layout-preview.css') > -1);
    if(layoutOldLink && layoutOldLink.getAttribute('href') === event.detail.cssUrl) return;
    if(layoutOldLink) layoutOldLink.remove();
    const layoutNewLink = document.createElement("link");
    layoutNewLink.href = event.detail.cssUrl + '?' + new Date().getTime();
    layoutNewLink.type = 'text/css';
    layoutNewLink.rel = 'stylesheet';
    document.head.append(layoutNewLink);
}) as EventListener);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
